import { render } from "./UploadTotalsHour.vue?vue&type=template&id=21eb165f&ts=true"
import script from "./UploadTotalsHour.vue?vue&type=script&lang=ts"
export * from "./UploadTotalsHour.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__